module.exports = __webpack_public_path__ + "img/banner-background-mobile.6c8b193.png";